import { useMount } from '@simplywallst/ui-core';

import { useInitializeProviderConnection } from '../../components/PortfolioLinking';

import { sentryCaptureMessage } from '@/components/Sentry';
import { useReduxStateForPortfolioLinkingSuccess } from './hooks/useReduxStateForPortfolioLinkingSuccess';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const SharesightLinkingSuccess = ({ onSuccess, onError }: Props) => {
  const { code } = useReduxStateForPortfolioLinkingSuccess();

  const { mutate } = useInitializeProviderConnection({
    onError,
    onSuccess,
  });

  useMount(() => {
    if (typeof code === 'undefined') {
      sentryCaptureMessage({
        team: 'wombats',
        message:
          'temporary access token is not defined in PortfolioLinkingSuccess page url',
      });
      onError();
    } else {
      mutate({ provider: 'sharesight', code });
    }
  });

  return null;
};
